module.exports = __webpack_public_path__ + "img/head_animals.3f89eb70.png";